<hr-customer-edit-verified
  (onUpdate)="onUpdateVerified($event)"
  [customer]="customer"
></hr-customer-edit-verified>
<hr-customer-edit-contracts
  [customerContracts]="customer?.customerContracts"
  [contractTypes]="contractTypes"
  [customerId]="customer?.customerId"
  (onUpdate)="onUpdateContract($event)"
></hr-customer-edit-contracts>
